import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';

// No StrictMode: double-mounting would connect and tear down rooms twice.
createRoot(document.getElementById('root') as HTMLElement).render(<App />);
